import { ComponentProps, useState, type FC } from 'react';

import { JobList } from 'components';
import { useJobSearch } from 'helpers';

type Props = Readonly<{
  customerId?: string;
}>;

export const CustomerJobs: FC<Props> = (props) => {
  const { customerId } = props;

  const [page, setPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);

  const [jobs, total = 0] = useJobSearch({
    searchBy: 'customer_id',
    searchValue: customerId,
    page,
    recordsPerPage,
  });

  const paginationMetadata: ComponentProps<typeof JobList>['paginationMetadata'] = {
    current_page: page,
    onChange(page, pageSize) {
      setPage(page);
      setRecordsPerPage(pageSize);
    },
    pageSize: recordsPerPage,
    total,
  };

  return (
    <>
      <title>Customer Jobs</title>
      <JobList jobs={jobs} paginationMetadata={paginationMetadata} hideColumns={['customerName', 'address']} />
    </>
  );
};
